import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { toast } from 'react-toastify';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';


const PlanModal = ({ isOpen, setIsOpen, data, setData, sliderFetch }) => {
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [productOptions, setProductOptions] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showBackgroundModal, setShowBackgroundModal] = useState(false);
    const [images, setImages] = useState([]);
    const token = decryptToken("accessToken") || ""

    const fetchImages = async () => {
        try {
            const res = await fetch(`${url}/api/images/${isLoggedIn.main_id}`);
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${isLoggedIn.main_id}`);
            const res = await response.json();

            const options = res.map((product) => ({
                value: product.product_id,     // or product.id
                label: product.title,
                ...product              // 👈 include all product fields here
            }));

            setProductOptions(options);
        } catch (error) {
            console.error(error);
        }
    };

    console.log(data)
    useEffect(() => {
        fetchProducts();
    }, []);

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleProductSelect = (selectedOption) => {
        const fullProduct = productOptions.find(p => p.value === selectedOption.value);
        setData({ ...data, product: fullProduct });
    };

    const handleImageSelect = (field, img) => {
        setData((prev) => ({ ...prev, [field]: `${url}${img.url}` }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...data,

        };

        const response = await fetch(`${url}/plan${data.id ? `/${data.id}` : ""}`, {
            method: data.id ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        });

        const res = await response.json();
        if (response.ok) {
            toast.success(data.id ? "Offer updated successfully" : "Offer saved successfully");
            sliderFetch();
            setIsOpen(false);
        } else {
            toast.error("Failed to save slider");
        }
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Plan Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>

                    {/* Offer Title */}
                    <div className="oms-form-group">
                        <label htmlFor="plan_name" className="oms-form-label">Plan Name</label>
                        <input
                            type="text"
                            id="plan_name"
                            name="plan_name"
                            value={data.plan_name}
                            onChange={handleChange}
                            placeholder="Enter Plan Name"
                        />
                    </div>

                    {/* Offer Description */}
                    <div className="oms-form-group">
                        <label htmlFor="validity_in_month" className="oms-form-label">Validity (Month)</label>
                        <input
                            type="text"
                            id="validity_in_month"
                            name="validity_in_month"
                            value={data.validity_in_month}
                            onChange={handleChange}
                            placeholder="Enter Validity in months"
                        />
                    </div>

                    {/* Offer Link */}
                    <div className="oms-form-group">
                        <label htmlFor="cut_off_price" className="oms-form-label">MRP</label>
                        <input
                            type="text"
                            id="cut_off_price"
                            name="cut_off_price"
                            value={data.cut_off_price}
                            onChange={handleChange}
                            placeholder="Enter Mrp"
                        />
                    </div>

                    {/* Offer Tagline */}
                    <div className="oms-form-group">
                        <label htmlFor="price" className="oms-form-label">Sale Price</label>
                        <input
                            type="text"
                            id="price"
                            name="price"
                            value={data.price}
                            onChange={handleChange}
                            placeholder="Enter Price"
                        />
                    </div>




                    {/* Actions */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>

    );
};


export default PlanModal;
